import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { NavLink, Outlet } from "react-router-dom";
import BackArrowMenu from "../../UI/BackArrowMenu";
import classes from "./CurriculumMenu.module.css"
import * as PathRouter from '../../../models/PathRoute'
import { getCoursesData } from "../../../store/discipline-action";
import LeftSidePopup from "../../UI/LeftSidePopup";
import { selectDisciplinesCurrentYear } from "../../../store/discipline-slice";
import ScrollLTR from "../../lms-shared/UI/ScrollLTR";

const CurriculumMenu = () => {
    const { texts } = useSelector(state => state.translate);
    const disciplines = useSelector(state => selectDisciplinesCurrentYear(state));
    const { homeUrl } = useSelector(state => state.application);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const applicationId = useSelector(state => state.application.applicationId);

    useEffect(() => {
        if (!disciplines && applicationId)
            dispatch(getCoursesData());
    }, [applicationId])


    return <div className={classes.CurriculumMenu}>
        <LeftSidePopup>
            <BackArrowMenu title={texts.dashboardCurriculum} onClick={() => navigate(homeUrl + '/' + PathRouter.CURRICULUMS)} />
            <ScrollLTR dropStyle={{ height: "calc(100vh - 139px)" }}>
                <div className={classes.Links}>
                    {disciplines && disciplines.map(c => <div key={c.id}><NavLink className={({ isActive }) => isActive ? `${classes.Select} ${classes.Link}` : classes.Link} to={`../curriculum/${c.id}`}>{c.name}</NavLink></div>)}
                </div>
            </ScrollLTR>
        </LeftSidePopup>
        <Outlet></Outlet>
    </div>
}

export default CurriculumMenu;